export function setProductIsActive (isActive: boolean | null | undefined, menuTypeStatus: Array<boolean | null | undefined>): boolean | null {
  if (isActive == null) return null

  if (!isActive && (menuTypeStatus[0] === true || menuTypeStatus[1] === true || menuTypeStatus[2] === true)) return false

  return !isActive
}
